import styled from "@emotion/styled";
import { palette } from "@jnpmedi/grebob";
import { DocumentMarker, useDocumentMarkerContext } from "@newHooks/context/document/documentMarker.context";
import { colorPrimaryText } from "@assets/styles/colors";
import { DocumentSignerAttrType } from "@maven-rest/docs/DocumentSign.dto";

const UNLINK_BUTTON_SIZE = "20px";
const UNLINK_BUTTON_GAP = "6px";

export function EConsentUnlinkButton({ marker }: { marker: DocumentMarker }) {
  const { markers, setMarkers } = useDocumentMarkerContext();

  const unlink = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    uuid: string,
    attr: DocumentSignerAttrType,
    groupUuid: string,
    attrUuid: string
  ) => {
    e.stopPropagation();

    setMarkers(
      markers.filter(
        (marker) => !(marker.signerUuid === uuid && marker.attr === attr && marker.groupUuid === groupUuid && marker.attrUuid === attrUuid)
      )
    );

    if (attr === DocumentSignerAttrType.TemplateMark) {
      setMarkers(
        markers.filter((marker) => {
          if (marker.groupUuid === attrUuid) {
            return false;
          } else if (marker.attrUuid === attrUuid) {
            return false;
          } else {
            return true;
          }
        })
      );
    }

    if (
      (attr === DocumentSignerAttrType.Name || attr === DocumentSignerAttrType.Signature || attr === DocumentSignerAttrType.Date) &&
      markers.some((marker) => marker.attrUuid === groupUuid && marker.attr === DocumentSignerAttrType.TemplateMark)
    ) {
      const parentTemplateMarker = markers.find(
        (marker) => marker.attrUuid === groupUuid && marker.attr === DocumentSignerAttrType.TemplateMark
      );
      const templateMarkerChildren = markers.filter((marker) => marker.groupUuid === parentTemplateMarker?.attrUuid);

      //case: templateMarker의 child가 1개일 때, child를 삭제하면 templateMarker도 삭제
      const templateMarkerChildLength = templateMarkerChildren.length;

      if (templateMarkerChildLength === 0 || templateMarkerChildLength === 1) {
        setMarkers(
          markers.filter((marker) => {
            if (marker.groupUuid === parentTemplateMarker?.attrUuid || marker.attrUuid === parentTemplateMarker?.attrUuid) {
              return false;
            } else {
              return true;
            }
          })
        );

        return;
      }

      //case: templateMarker의 맨 왼쪽 child를 삭제할 때 핸들링
      const sortedAscTemplateMarkerChildrenX = templateMarkerChildren.sort((a, b) => a.x! - b.x!);
      const gap = sortedAscTemplateMarkerChildrenX[1].x! - sortedAscTemplateMarkerChildrenX[0].x!;

      if (sortedAscTemplateMarkerChildrenX[0].attr === attr) {
        setMarkers(
          markers
            .map((el) => {
              if (el.attr === DocumentSignerAttrType.TemplateMark && el.attrUuid === parentTemplateMarker?.attrUuid) {
                return {
                  ...el,
                  x: Math.min(99, Math.max(0, (el.x ?? 0) + (gap / 595) * 100)),
                };
              } else if (el.groupUuid === parentTemplateMarker?.attrUuid) {
                return {
                  ...el,
                  x: (el.x ?? 0) - gap,
                };
              } else {
                return el;
              }
            })
            .filter(
              (marker) =>
                !(marker.signerUuid === uuid && marker.attr === attr && marker.groupUuid === groupUuid && marker.attrUuid === attrUuid)
            )
        );
        return;
      }
    }
  };

  return (
    <StyledUnlinkButton
      className="notranslate"
      onClick={(e) => unlink(e, marker.signerUuid, marker.attr, marker.groupUuid, marker.attrUuid)}
    >
      close
    </StyledUnlinkButton>
  );
}

const StyledUnlinkButton = styled("span")(() => ({
  position: "absolute",
  top: "calc(50% - 10px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "16px",
  right: `calc(-1 * ${UNLINK_BUTTON_SIZE} + (-1 * ${UNLINK_BUTTON_GAP}))`,
  width: UNLINK_BUTTON_SIZE,
  height: UNLINK_BUTTON_SIZE,
  lineHeight: UNLINK_BUTTON_SIZE,
  borderRadius: "50%",
  backgroundColor: palette["grey050"],
  color: colorPrimaryText,
  fontFamily: "Material Icons Outlined",
  cursor: "pointer",
  opacity: 0,
}));
